import { render, staticRenderFns } from "./LoadingRing.vue?vue&type=template&id=871d7166&scoped=true"
import script from "./LoadingRing.vue?vue&type=script&lang=js"
export * from "./LoadingRing.vue?vue&type=script&lang=js"
import style0 from "./LoadingRing.vue?vue&type=style&index=0&id=871d7166&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871d7166",
  null
  
)

export default component.exports